import React from 'react';
import { translate } from 'react-i18next';
import { Button } from 'primereact/button';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBInputField from '../../shared/form_components/CBInputField';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBPromptModal from '../../shared/CBPromptModal';

const MAX_NAME_LENGTH = 255;

// One toimipiste: inline rename + save, delete with confirmation. With `isNew`
// the row is the "add" form at the bottom of the table.
class BusinessUnitRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: { name: props.businessUnit ? props.businessUnit.name : '' },
      deleteModalIsOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { businessUnit } = this.props;
    if (businessUnit && prevProps.businessUnit !== businessUnit) {
      this.setState({ formData: { name: businessUnit.name } });
    }
  }

  updateFormState = (changedObject) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  isChanged = () => {
    const { businessUnit } = this.props;
    const { formData } = this.state;
    if (!businessUnit) return formData.name.trim().length > 0;
    return businessUnit.name !== formData.name.trim();
  };

  isValid = () => {
    const { formData } = this.state;
    const name = formData.name.trim();
    return name.length > 0 && name.length <= MAX_NAME_LENGTH;
  };

  saveItem = () => {
    const {
      isNew, businessUnit, organizationId, createBusinessUnit, updateBusinessUnit,
    } = this.props;
    const { formData } = this.state;
    const name = formData.name.trim();
    if (isNew) {
      createBusinessUnit({ organization: organizationId, name });
      this.setState({ formData: { name: '' } });
    } else {
      updateBusinessUnit(businessUnit.id, { name }, organizationId);
    }
  };

  deleteItem = () => {
    const { businessUnit, organizationId, deleteBusinessUnit } = this.props;
    deleteBusinessUnit(businessUnit.id, organizationId);
    this.setState({ deleteModalIsOpen: false });
  };

  render() {
    const { formData, deleteModalIsOpen } = this.state;
    const { isNew, t, canEdit } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <React.Fragment>
            <tr style={getStyle(screenSize, styles, 'row')}>
              <td style={getStyle(screenSize, styles, 'tableTd')}>
                <CBInputField
                  name='name'
                  value={formData.name}
                  onChange={this.updateFormState}
                  noValidationOnChange
                  blurOnEnter
                  placeholder={isNew ? t('newPlaceholder') : ''}
                  className={isNew ? 'white-placeholder-input' : undefined}
                  disabled={!canEdit}
                />
              </td>
              <td style={getStyle(screenSize, styles, 'tableTdActions')}>
                {canEdit && (
                  <div style={getStyle(screenSize, styles, 'actionsContainer')}>
                    <CBButtonWithIconSmall
                      text={isNew ? t('addButton') : t('saveButton')}
                      onClick={this.saveItem}
                      icon={isNew ? '/img/icon_plus.svg' : '/img/icon_save.svg'}
                      disabled={!this.isValid() || !this.isChanged()}
                    />
                    {!isNew && (
                      <Button
                        icon='pi pi-times'
                        rounded
                        outlined
                        severity='danger'
                        aria-label='Delete'
                        size='medium'
                        onClick={() => this.setState({ deleteModalIsOpen: true })}
                      />
                    )}
                  </div>
                )}
              </td>
            </tr>
            {!isNew && (
              <CBPromptModal
                modalIsOpen={deleteModalIsOpen}
                closeModal={() => this.setState({ deleteModalIsOpen: false })}
                afterOpenModal={() => {}}
                title={t('deleteTitle')}
                text={t('deleteText', { name: formData.name })}
                buttonText={t('deleteButton')}
                performAction={this.deleteItem}
              />
            )}
          </React.Fragment>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    actionsContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    tableTd: {
      border: '1px solid rgba(255, 255, 255, .3)',
      color: '#FFFFFF',
      paddingLeft: 8,
      paddingRight: 8,
      minWidth: 240,
    },
    tableTdActions: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    row: {
      marginBottom: 8,
    },
  },
};

export default translate('BusinessUnits')(BusinessUnitRow);
